/**
 * Sprint selectors
 */

import { RootState } from "types";

import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./initialState";

const selectDomain = (state: RootState) =>
  state?.sprintDetailsState || initialState;

export const selectSprintsDetails = createSelector(
  [selectDomain],
  (state) => state.sprintDetails
);
export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);
export const selectButtonLoading = createSelector(
  [selectDomain],
  (state) => state.buttonLoading
);
export const selectUnresolvedLoading = createSelector(
  [selectDomain],
  (state) => state.UnresolvedLoading
);
export const selectUnresolvedTickets = createSelector(
  [selectDomain],
  (state) => state.unResolvedTicketList
);
export const selectLaunchSprintWrapper = createSelector(
  [selectDomain],
  (state) => state.LaunchSprintWrapper
);
export const selectNotStartedSprintDeleteWrapper= createSelector(
  [selectDomain],
  (state) => state.notStartedSprintDeleteWrapper
);
export const selectCompleteSprintDeleteWrapper = createSelector(
  [selectDomain],
  (state) => state.completeSprintDeleteWrapper
);
export const selectCompleteSprintWrapper= createSelector(
  [selectDomain],
  (state) => state.completeSprintWrapper
);
export const selectBurndownChartWrapper= createSelector(
  [selectDomain],
  (state) => state.burndownChartWrapper
);
export const selectEffortsByAssigneesChartWrapper= createSelector(
  [selectDomain],
  (state) => state.effortsByAssigneesChartWrapper
);
export const selectDashboardDetails= createSelector(
  [selectDomain],
  (state) => state.dashboardDetails
);

export const selectDashboardLoading= createSelector(
  [selectDomain],
  (state) => state.dashboardLoading
);


